import React from 'react';
import { formatVoucherDuration } from './durationUtil';

const ClassicOrangeTemplate = ({ vouchers, companyLogo = '', companyName = '', batchHeader, templateSettings }) => {
  const _dCfg = {
    font_brand: 7, font_plan: 6,
    font_label: 6, font_code: 7,
    plan_format: '{duration} - {price}',
    label_text: 'Voucher Code', prefix_text: 'No.Voucher :',
  };
  const cfg = { ..._dCfg, ...(templateSettings || {}) };
  const _fmtPlan = (dur, price) => (cfg.plan_format || '{duration} - {price}')
    .replace('{duration}', dur || '')
    .replace('{price}', price || '')
    .replace(/^\s*-\s*|\s*-\s*$/g, '').trim();
  return (
    <div className="print-container-classic-orange print-root">
      <style>{`
        @page {
          size: A4 landscape;
          margin: 2mm;
        }

        @media print {
          /* Reset all scaling on parents so 1mm = 1mm */
          html, body { width: 100%; height: 100%; margin: 0 !important; padding: 0 !important; background: white !important; }
          html *:not(.print-root):not(.print-root *) { visibility: hidden !important; }
          .print-root, .print-root * { visibility: visible !important; }
          .print-root {
            position: absolute !important;
            left: 0 !important; top: 0 !important;
            transform: none !important;
            width: 100% !important;
          }
        }

        
        .print-container-classic-orange {
          width: 297mm;
          margin: 0 auto;
          padding: 2mm;
          background: #ffffff;
          display: flex;
          flex-wrap: wrap;
          gap: 0.5mm;
          align-content: flex-start;
        }
        
        @media print {
          .print-container-classic-orange {
            background: white;
            padding: 0;
          }
        }
        
        .classic-orange-card {
          width: calc((100% - 6 * 0.5mm) / 7);
          height: 28mm;
          background: linear-gradient(135deg, #ff8c42 0%, #ff6b35 100%);
          padding: 0;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          border-radius: 2mm;
          overflow: hidden;
          border: 1px dashed #ccc;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
          flex-shrink: 0;
          page-break-inside: avoid;
        }
        
        .classic-orange-voucher-number {
          background: rgba(0, 0, 0, 0.3);
          color: white;
          font-size: 5pt;
          font-weight: 800;
          padding: 0.5mm 1mm;
          text-align: left;
        }
        
        .classic-orange-brand {
          background: #ff8c42;
          color: white;
          font-size: ${cfg.font_brand}pt;
          font-weight: 900;
          text-align: center;
          padding: 0.5mm 0.8mm;
          letter-spacing: 0.3mm;
          border-top: 1.5px solid white;
          border-bottom: 1.5px solid white;
          white-space: nowrap;
        }
        
        .classic-orange-content {
          display: flex;
          flex-direction: column;
          padding: 1mm 1mm 0mm 1mm;
          gap: 0.8mm;
        }
        
        .classic-orange-price-box {
          background: white;
          border: 1.5px solid white;
          border-radius: 1mm;
          padding: 0.8mm;
          text-align: center;
          box-shadow: 0 1px 2px rgba(0,0,0,0.2);
        }
        
        .classic-orange-price-text {
          font-size: ${cfg.font_plan}pt;
          font-weight: 800;
          color: #333;
          margin: 0;
          line-height: 1.2;
        }
        
        .classic-orange-code-label {
          color: white;
          font-size: ${cfg.font_label}pt;
          font-weight: 700;
          text-align: center;
          margin-top: 0mm;
          margin-bottom: 0.3mm;
          text-shadow: 0 1px 2px rgba(0,0,0,0.3);
        }
        
        .classic-orange-code-box {
          background: white;
          border: 1.5px solid white;
          border-radius: 1mm 1mm 0 0;
          padding: 1mm 0.8mm;
          text-align: center;
          box-shadow: 0 1px 2px rgba(0,0,0,0.2);
          margin-bottom: 0mm;
        }
        
        .classic-orange-code-value {
          font-size: ${cfg.font_code}pt;
          font-weight: 900;
          color: #000;
          letter-spacing: 0.3mm;
          margin: 0;
          line-height: 1.1;
        }
        .classic-orange-brand-logo {
          max-height: 5mm;
          max-width: 100%;
          object-fit: contain;
          display: block;
          margin: 0 auto;
        }
      `}
      </style>
      
      {batchHeader}
      {vouchers.map((voucher, index) => (
        <div key={voucher.id || index} className="classic-orange-card" data-voucher-card>
          <div className="classic-orange-voucher-number">
            {cfg.prefix_text}{String(index + 1).padStart(2, '0')}
          </div>
          
          <div className="classic-orange-brand">
            {companyLogo ? (
              <img src={companyLogo} alt={companyName || 'Logo'} className="classic-orange-brand-logo" />
            ) : (
              <span>{companyName || 'ISP Provider'}</span>
            )}
          </div>
          
          <div className="classic-orange-content">
            <div className="classic-orange-price-box">
              <p className="classic-orange-price-text">
                {_fmtPlan(formatVoucherDuration(voucher), voucher.price ? `Rp. ${Number(voucher.price).toLocaleString('id-ID')}` : '')}
              </p>
            </div>
            
            <div className="classic-orange-code-label">
              {cfg.label_text}
            </div>
            
            <div className="classic-orange-code-box">
              <p className="classic-orange-code-value">{voucher.voucher_code}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ClassicOrangeTemplate;
